module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('custom-header'), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h1', [_vm._v("Users")]), _vm._v(" "), _c('users-table', {
    attrs: {
      "url": _vm.url
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8ce460c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dothraki/Users.vue
// module id = 250
// module chunks = 1